<template>

  <modalo
    :title="`Aparentemente ${notHired} posto(s) não foram preenchidos.`"
    type="mini"
    @hideModal="hideModal()">

    <h5 class="mb-3">Informe o motivo.</h5>

    <div
      class="list-group"
      v-if="cancelReasons.length">
      <label
        class="list-group-item list-group-item-action"
        :class="{'list-group-item-action list-group-item-primary': cancelReasonId === item._id}"
        v-for="(item, index) in cancelReasons"
        :key="index">
        <input
          type="radio"
          :value="item._id"
          v-model="cancelReasonId">
        {{ item.name }}
      </label>
    </div>

    <div class="mt-3">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="!cancelReasonId"
        @click="archived(cancelReasonId)">{{ $t('Archive') }}</button>
    </div>
    
  </modalo>

</template>

<script>
export default {
  name: 'JobCancelReasons',
  components: {
  },
  props: [
  ],
  data () {
    return {
      cancelReasonId: false
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    cancelReasons () {
      return this.$store.getters.getCancelReasons
    },
    notHired () {
      return this.job.openings - this.job.pipeline.hired
    }
  },
  created () {
  },
  methods: {
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    archived
    */
    archived (cancelReasonId) {
      this.$store.dispatch('updateJobArchive', {
        _id: this.job._id,
        cancel_reason_id: cancelReasonId
      })
      this.hideModal()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobHeader/JobCancelReasons.vue